import LevelBar from '@app/src/components/LevelBar'
import type { AssessmentData } from '@app/src/pages/Assessments/useOrganizedAssessmentData'
import { AssessmentLevelNamesType } from '@app/src/types/resourceExplorer'
import { Box, ButtonBase, Stack, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import ParentCellOrFragment from './ParentCellOrFragment'

type PieChartCellProps = {
  assessment: AssessmentData
  disableCell?: boolean
  noPublicData?: boolean
  onClick?: () => void
}

const PieChartCell: React.FC<PieChartCellProps> = ({ assessment, disableCell, noPublicData = false, onClick }) => {
  const { formatMessage } = useIntl()
  const intervals = assessment?.assessmentTemplate.levels ?? 5
  const levelNamesType = assessment?.assessmentTemplate.levelNamesType ?? AssessmentLevelNamesType.Intervals
  const levelTranslationKey =
    assessment.assessmentTemplate.levels === 3
      ? `assessments.${levelNamesType}.3.level${assessment.totalLevel}`
      : `assessments.${levelNamesType}.5.level${assessment.totalLevel}`

  const percentage = assessment?.percentage ?? 0

  const content = (
    <LevelBar
      value={assessment.totalLevel}
      percentage={percentage}
      levelsCount={intervals}
      assessmentType={assessment.assessmentTemplate.assessmentType}
      levelNamesType={levelNamesType}
      thresholds={assessment.assessmentTemplate.levelThresholdPercentages}
    />
  )

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <Box display="inline-block">
        <Tooltip
          arrow
          placement="bottom"
          title={
            <>
              {formatMessage(
                { id: 'assessments.assessedAsLevel' },
                {
                  level: formatMessage({ id: levelTranslationKey }),
                  score: percentage,
                  br: <br />,
                },
              )}
              {noPublicData && (
                <Typography variant="body2" lineHeight="2.5rem">
                  {formatMessage({ id: 'schemas.request.noPublicData' }, { value: 'N/A' })}
                </Typography>
              )}
            </>
          }
        >
          <Stack alignItems="flex-start" spacing={1} sx={{ display: 'inline-flex' }}>
            {onClick ? <ButtonBase onClick={onClick}>{content}</ButtonBase> : content}
          </Stack>
        </Tooltip>
      </Box>
    </ParentCellOrFragment>
  )
}

export default PieChartCell
